export default __webpack_public_path__ + "static/media/gardenscapes.7a5dc0da.webp";